import React, { useContext, useState } from 'react';

import { AppContext } from 'contexts';
import { makeStyles, Box, Modal, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    messageModal: {
      width: 300,
      position: 'relative',
      top: '20%',
      marginLeft: 'auto',
      marginRight: 'auto',
      alignContent: 'center',
      backgroundColor: 'white',
      padding: 30,
      animation: 'slide-down .2s ease-in',
      '@media (max-width: 767px)': {
        top: 101,
      },
    },
    title: {
      marginBottom: 20,
    },
    button: {
      marginRight: 20,
    },
  };
});
function MessageModal() {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const { showMessage, listing, modalMessageType } = appContext;
  const brokerPrefix = `Broker ${listing?.broker?.firstname} ${listing?.broker?.lastname}`;

  const getMessage = () => {
    switch (modalMessageType) {
      case 'user-join':
        return `${brokerPrefix} rejoint l'appel`;
      case 'user-left':
        return `${brokerPrefix} a quitté l'appel`;
      case 'user-lost-connection':
        return `${brokerPrefix} perdue la déconnexion`;
      case 'call-broker-error':
        return `${brokerPrefix} ne peut pas recevoir l'appel`;
      case 'broker-not-available':
        return `${brokerPrefix} n'est pas disponible`;
      case 'init-error':
        return "Échec de l'initialisation de votre audio, veuillez vérifier votre configuration audio";
      default:
        return '';
    }
  };

  return (
    <div>
      <Modal
        open={showMessage}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className={classes.messageModal}>
          <Typography className={classes.title}>{getMessage()}</Typography>
        </Box>
      </Modal>
    </div>
  );
}
export default MessageModal;
